(function () {
  "use strict";

  angular
    .module("admin.checklist.service", [])
    .factory("ChecklistService", ChecklistService);

  /** @ngInject */
  function ChecklistService($http, $q, API) {
    function search(t, st, start, limit) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/checklist_definitions/search?t=" +
            t +
            "&st=" +
            st +
            "&start=" +
            start +
            "&limit=" +
            limit +
            "&sort=id-desc"
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listDraft(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/checklist_definitions/unpublished?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listPublished(start, limit) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/checklist_definitions/published?start=" +
            start +
            "&limit=" +
            limit
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listUnpublished(start, limit) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/checklist_definitions/archived?start=" +
            start +
            "&limit=" +
            limit
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listEmptyState() {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/checklist_empty_states")
        .success(defered.resolve);

      return defered.promise;
    }

    function get(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/checklist_definitions/" + id)
        .success(defered.resolve);

      return defered.promise;
    }

    function getEmptyState(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/checklist_empty_states/" + id)
        .success(defered.resolve);

      return defered.promise;
    }

    function save(model) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/checklist_definitions", model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function saveEmptyState(model) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/checklist_empty_states", model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/checklist_definitions/" + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateEmptyState(id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/checklist_empty_states/" + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/checklist_definitions/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeEmptyState(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/checklist_empty_states/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function publish(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/checklist_definitions/" + id + "/publish")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function unpublish(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/checklist_definitions/" + id + "/unpublish")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listSegmentation(id) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL + "admin/checklist_definitions/" + id + "/user_segments"
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listSegmentationUsers(id) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/checklist_definitions/" +
            id +
            "/user_segmenter_users"
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function addSegmentation(id, segmentId) {
      var defered = $q.defer();

      $http
        .post(
          API.API_URL +
            "admin/checklist_definitions/" +
            id +
            "/user_segments/" +
            segmentId
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeSegmentation(id, segmentId) {
      var defered = $q.defer();

      $http
        .delete(
          API.API_URL +
            "admin/checklist_definitions/" +
            id +
            "/user_segments/" +
            segmentId
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function getTranslation(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/checklist_definition_translations/" + id)
        .success(defered.resolve);

      return defered.promise;
    }

    function getTranslationEmptyState(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/checklist_empty_state_translations/" + id)
        .success(defered.resolve);

      return defered.promise;
    }

    function saveTranslation(id, model) {
      var defered = $q.defer();

      $http
        .post(
          API.API_URL +
            "admin/checklist_definitions/" +
            id +
            "/checklist_definition_translations?automatic=true",
          model
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function saveTranslationEmptyState(id, model) {
      var defered = $q.defer();

      $http
        .post(
          API.API_URL +
            "admin/checklist_empty_states/" +
            id +
            "/checklist_empty_state_translations?automatic=true",
          model
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateTranslation(id, model) {
      var defered = $q.defer();

      $http
        .put(
          API.API_URL +
            "admin/checklist_definition_translations/" +
            id +
            "?automatic=true",
          model
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateTranslationEmptyState(id, model) {
      var defered = $q.defer();

      $http
        .put(
          API.API_URL +
            "admin/checklist_empty_state_translations/" +
            id +
            "?automatic=true",
          model
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeTranslation(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/checklist_definition_translations/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeTranslationEmptyState(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/checklist_empty_state_translations/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listTranslations(id) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/checklist_definitions/" +
            id +
            "/checklist_definition_translations"
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listTranslationsEmptyState(id) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/checklist_empty_states/" +
            id +
            "/checklist_empty_state_translations"
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listReward(id) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/checklist_definitions/" +
            id +
            "/cdrts?sort=n-asc"
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listRewardsType() {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/reward_types")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function getReward(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/checklist_definitions/" + id + "/cdrts")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function createReward(id, model) {
      var defered = $q.defer();

      $http
        .post(
          API.API_URL + "admin/checklist_definitions/" + id + "/cdrts",
          model
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateReward(id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/cdrts/" + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeReward(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/cdrts/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return {
      search: search,
      listDraft: listDraft,
      listPublished: listPublished,
      listUnpublished: listUnpublished,
      get: get,
      getEmptyState: getEmptyState,
      save: save,
      saveEmptyState: saveEmptyState,
      update: update,
      updateEmptyState: updateEmptyState,
      remove: remove,
      removeEmptyState: removeEmptyState,
      publish: publish,
      unpublish: unpublish,
      listSegmentation: listSegmentation,
      listSegmentationUsers: listSegmentationUsers,
      addSegmentation: addSegmentation,
      removeSegmentation: removeSegmentation,
      saveTranslation: saveTranslation,
      saveTranslationEmptyState: saveTranslationEmptyState,
      updateTranslation: updateTranslation,
      updateTranslationEmptyState: updateTranslationEmptyState,
      removeTranslation: removeTranslation,
      removeTranslationEmptyState: removeTranslationEmptyState,
      listTranslations: listTranslations,
      listTranslationsEmptyState: listTranslationsEmptyState,
      getTranslation: getTranslation,
      getTranslationEmptyState: getTranslationEmptyState,
      listReward: listReward,
      listRewardsType: listRewardsType,
      getReward: getReward,
      createReward: createReward,
      updateReward: updateReward,
      removeReward: removeReward,
      listEmptyState: listEmptyState,
    };
  }
})();
